import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class SamlRedirect extends BaseModel {
  redirectUrl?: string;

  constructor(model: Partial<SamlRedirect> = {}) {
    super(model);

    this.redirectUrl = model.redirectUrl;
  }
}
